define(function(require) {
    var _ = require('underscore');
    var BaseReplacerView = require('common/base.replacer.view');
    var user = require('user');
    var core = require('core');
    var device = require('util/device.util');
    var url = require('util/url.util');
    var conf = require('config');

    return BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) {
            this.name = options.name;
        },

        render: function() {
            if (device.formFactor === 'desktop') {
                return this;
            } else if (this.name === 'VIRTUAL_CARD') {
                this.renderQRCode();
            } else {
                this.renderAppleWallet();
            }

            return this;
        },

        renderQRCode: function() {
            this.el.innerHTML = this.tmpl('qr-code', {
                qr_code_src: this.getUrl('qr_code')
            });
        },

        renderAppleWallet: function() {
            if (device.formFactor === 'mobile' && device.browserName === 'safari') {
                this.el.innerHTML = this.tmpl('apple-wallet', {
                    href: this.getUrl()
                });
            }
        },

        /**
         * [configureUserDetails Extend user details data
         * with necessary params
         * @return {[Object]} [New object with merged data]
         */
        extendUserDetails: function() {
            var details = user.get('userDetails');

            if (!details.activeIdToken) {
                core.warn('\'RFID card in Player Info\' isn\'t configured on the IMS');
            }

            return _.extend({
                cardid: details.activeIdToken
            }, details);
        },

        getUrl: function(type) {
            var endpointURL = type === 'qr_code' ? 'qrEndpointURL' : 'pkpassEndpointURL';
            var urlParams = ['cardid', 'firstname', 'lastname']; // default values
            var src = conf.get(endpointURL);
            var charIndex, params;

            if (!src) {
                core.warn('Isn\'t configured "' + endpointURL + '" on the Admin panel');
                return false;
            }

            charIndex = src.indexOf('?');

            if(charIndex > -1) {
                urlParams = _.keys(url.getURLParams(src));
                src = src.substring(0, charIndex);
            }

            params = this.generateParams(this.extendUserDetails(), urlParams);

            return src + '?' + url.serialize(params);
        },

        generateParams: function(details, params) {
            return _.keys(details).reduce(function(result, key) {
                params.forEach(function(value) {
                    if (value.toLowerCase() === key.toLowerCase()) {
                        result[value] = details[key];
                    }
                });
                return result;
            }, {});
        }

    },{
        nameOfReplacers: [
            'VIRTUAL_CARD',
            'ADD_TO_APPLE_WALLET'
        ]
    });
});
